module.exports = __webpack_public_path__ + "static/media/pelvis.9eacaeed.jpg";